enum Permission {
  ReadBillableReport = 'read:billable_report',
  ReadCompanies = 'read:companies',
  WriteCompanies = 'write:companies',
  ReadCommodities = 'read:commodities',
  WriteCommodities = 'write:commodities',
}

export default Permission
